import { PrimaryFormAutoComplete } from "react-common-ui-library";
import {
  EMAIL_LANGUAGE,
  EMAIL_LANGUAGE_HELPER_TEXT,
  EMAIL_LANGUAGE_LABEL,
  EMAIL_LANGUAGE_TOOLTIP_TEXT,
} from "../../Constants/CommonConstants";
import { manageReferenceDataSelector } from "../../Selectors/ReferenceDataSelector";
import { useSelector } from "react-redux";
import { fetchEmailLanguageOptions } from "../../Services/CommonServices";

/**
 * @description Email language dropdown
 * @returns {ReactNode} Renders the Email language dropdown that lets the user to select the language in which the emails will be sent.
 */
const EmailLanguage = () => {
  const { preferredLanguage } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  return (
    <PrimaryFormAutoComplete
      formProps={{
        name: EMAIL_LANGUAGE,
      }}
      labelProps={{
        labelText: EMAIL_LANGUAGE_LABEL,
        tooltipText: EMAIL_LANGUAGE_TOOLTIP_TEXT,
      }}
      fieldProps={{
        autoCompleteOptions: fetchEmailLanguageOptions(preferredLanguage),
      }}
      helperTextProps={{ helperText: EMAIL_LANGUAGE_HELPER_TEXT }}
    />
  );
};

export default EmailLanguage;
